module.exports = __webpack_public_path__ + "img/img-10-tarif.c263c0b7.webp";